import { backendApi } from "../dynamicBAseQuery";

export const jobPostingsApi = backendApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    JobAssignedList: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `JobAssignedList`,
        body: { ...args },
      }),
    }),

    getClientDropdown: builder.query({
      query: () => ({
        method: "GET",
        url: `client/getClientDropDown`,
      }),
    }),

    getCoordinatorDropdown: builder.query({
      query: () => ({
        method: "GET",
        url: `coordinatorDropDown`,
      }),
    }),

    recruiterList: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `recruiterList`,
        body: { ...args },
      }),
    }),

    selectRecruiterList: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `selectRecruiterList`,
        body: { ...args },
      }),
    }),

    assignRecruiter: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `assignRecruiter`,
        body: { ...args },
      }),
    }),

    saveDuplicate: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `saveDuplicate`,
        body: { ...args },
      }),
    }),

    coordinatorDialogDropDown: builder.query({
      query: () => ({
        method: "GET",
        url: `coordinatorDropDown`,
      }),
    }),

    getClientDropdownForJob: builder.query({
      query: () => ({
        method: "GET",
        url: `client/getClientDropDownForJobsave`,
      }),
    }),

    bindingEditJobPosting: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `JobPostingDetailsByPositionId`,
        body: { ...args },
      }),
    }),

    // Find Profiles screen (icon-1 from the job list screen)
    viewAllCandidateForJob: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `viewAllCandidateForJob`,
        params: args,
      }),
    }),

    eventsHistory: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `eventsHistory`,
        body: { ...args },
      }),
    }),

    selectProfile: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `selectProfile`,
        body: { ...args },
      }),
    }),

    // Profile submission (icon-3 from the Job list screen)
    eventDropDown: builder.query({
      query: () => ({
        method: "GET",
        url: `eventDropDown`,
      }),
    }),

    matchProfileList: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `matchProfileList`,
        body: { ...args },
      }),
    }),

    unassignProfile: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `unassignProfile`,
        body: { ...args },
      }),
    }),

    getMailContent: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `getMailContent`,
        body: { ...args },
      }),
    }),

    ExcelDataForProfileMatch: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `ExcelDataForProfileMatch`,
        body: { ...args },
      }),
    }),

    sendEmailforSubmittedClient: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `sendEmailforSubmittedClient`,
        body: { ...args },
      }),
    }),

    viewKeywords: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `viewKeywords`,
        body: { ...args },
      }),
    }),

    deleteEventHistory: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `deleteEventHistory`,
        body: { ...args },
      }),
    }),

    // The Below api's is not in use because excel download supports fetch or axios method

    profileMatchListExcelFileDownload: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `profileMatchListExcelFileDownload`,
        body: { ...args },
      }),
    }),

    downloadExcelFile: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `downloadExcelFile`,
        body: { ...args },
      }),
    }),
    ReferralJobList: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: `ReferralJobList`,
        body: { ...args },
      }),
    }),
    addJobPostings: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "updateJobPostingIsPostedStatusByPositionId",
        body: { ...args },
      }),
    }),
    jobApproveApi: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "jobApprovedAndReject",
        params: { ...args },
      }),
    }),
    getMailJobDescription: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "getMailJobDescription",
        body: { ...args },
      }),
    }),
    sendEmailJobDescription: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "sendEmailJobDescription",
        body: { ...args },
      }),
    }),
    getReferralJobMailDesc: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "getReferralJobMailDesc",
        body: { ...args },
      }),
    }),

    sendEmailReferralJob: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "sendEmailReferralJob",
        body: { ...args },
      }),
    }),

    profileZipProcess: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "profileZipProcess",
        body: { ...args },
      }),
    }),
    generateJobDescriptions: builder.mutation({
      query: (args) => ({
        method: "POST",
        url: "generateJobDescriptions",
        body: { ...args },
        responseHandler: (response) => response.text(),
      }),
    }),
  }),
});

export const {
  useGetJobPostingsTableDatasMutation,
  useJobAssignedListMutation,
  useGetClientDropdownQuery,
  useGetCoordinatorDropdownQuery,
  useRecruiterListMutation,
  useSelectRecruiterListMutation,
  useAssignRecruiterMutation,
  useSaveDuplicateMutation,
  useCoordinatorDialogDropDownQuery,
  useGetClientDropdownForJobQuery,
  useBindingEditJobPostingMutation,
  // Find profiles screen
  // useViewAllCandidateMutation,
  useViewAllCandidateForJobMutation,
  useEventsHistoryMutation,
  useSelectProfileMutation,
  // Profile Submission
  useEventDropDownQuery,
  useMatchProfileListMutation,
  useUnassignProfileMutation,
  useGetMailContentMutation,
  useExcelDataForProfileMatchMutation,
  useSendEmailforSubmittedClientMutation,
  useViewKeywordsMutation,
  useProfileMatchListExcelFileDownloadMutation,
  useDeleteEventHistoryMutation,
  useDownloadExcelFileMutation,
  useReferralJobListMutation,
  useAddJobPostingsMutation,
  useJobApproveApiMutation,
  useGetMailJobDescriptionMutation,
  useSendEmailJobDescriptionMutation,
  useGetReferralJobMailDescMutation,
  useSendEmailReferralJobMutation,
  useProfileZipProcessMutation,
  useGenerateJobDescriptionsMutation,
} = jobPostingsApi;
